import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import propTypes from 'prop-types';
import queryString from 'query-string';
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

import { showSnack } from '../../actions/uiActions';
import { getMessage } from '../../reducers/i18n';
import { getCurrentBaseUri } from '../../reducers/page';

import ActionIcon from '../buttons/ActionableIcon';
import Icon from '../Icon';
import Pin from '../sharing/PinterestIcon';
import FlatInput from '../styles/FlatInputShareMenu';


// TODO Merge with PinterestButton.

class PatternGalleryActionBarMenu extends React.Component {

    state = {
        anchorEl: null,
        open: false,
    };

    handleClick = event => {
        this.setState({
            open: true,
            anchorEl: event.currentTarget,
        });
    };

    handleRequestClose = () => {
        this.setState({
            open: false,
            anchorEl: null,
        });
    };

    handleNavigationToPattern = () => {
        this.props.navigateToPattern();
    };

    button = null;

    pinProps = {
        name: 'icon-pinterest2',
        width: '1.3em',
        height: '1.3em',
        iconColor: 'blueGrey.700',
    };

    linkProps = {
        name: 'icon-link',
        width: '1.4em',
        height: '1.2em',
        iconColor: 'blueGrey.700',
    };

    onCopyClick = () => {
        if (this.input && this.input.select) {
            // select text
            this.input.select();
            try {
                // copy text
                document.execCommand('copy');
                this.input.blur();
            }
            catch (err) {
                alert('please press Ctrl/Cmd+C to copy');
            }
        }
        this.props.showSavedToClipBoard(Date.now());
        this.handleRequestClose();
    };

    getUri = () => {
        let uri = this.props.shareBaseUri;
        uri = `${uri}/schnoff/${this.props.sewpatId}/${this.props.pattern.id}`;
        if (this.props.query) {
            var query = queryString.stringify(this.props.query);
            if (query.length > 0) {
                uri = `${uri}?${query}`;
            }
        }
        return uri;
    };

    getMedia = () => this.props.imgSrc ||
        (
            (
                (
                    this.props.pattern || {}
                ).thumbnails || {}
            ).xlargeDiscreet || {}
        ).url;

    getDescription = () => {
        const pattern = this.props.pattern;
        const description = `${this.props.sharePinterestPrefix} | ${pattern.title}: ${pattern.description}`;
        return description;
    };

    render() {
        const StyledMenuText = styled.span`
          margin-left: ${props => props.theme.space[5]};
        `;

        const StyledMenuIcon = styled(Icon)`
            &.stolo-appbar-menu {
              margin: 0;
            }
        `;

        return (
            <Fragment>
                <div
                    id={this.props.pattern.id}
                    key={this.props.pattern.id}
                    onClick={this.state.open ? null : this.handleClick}
                >

                    <ActionIcon
                        iconProps={{
                            name: 'icon-more_vert',
                            height: '1.75rem',
                            iconColor: 'blueGrey.700',
                        }}
                        handleClick={() => {}}
                    />
                </div>

                <Menu
                    id='simple-menu'
                    anchorEl={this.state.anchorEl}
                    open={this.state.open}
                    onClose={this.handleRequestClose}
                >

                    <MenuItem onClick={this.handleRequestClose}>
                        <Pin
                            iconProps={this.pinProps}
                            buttonText={this.props.sharePinterestLabel}
                            shareTarget={this.getUri()}
                            media={this.getMedia()}
                            description={this.getDescription()}
                        />
                    </MenuItem>

                    <MenuItem
                        component='div'
                        ref={element => {
                            this.button = element;
                        }} onClick={this.onCopyClick}
                    >
                        <FlatInput>
                            <Icon {...this.linkProps} /> {this.props.shareLinkLabel}
                            <input
                                ref={element => {
                                    this.input = element;
                                }}
                                type={'text'}
                                value={this.getUri()}
                                readOnly
                            />
                        </FlatInput>
                    </MenuItem>

                    <MenuItem onClick={this.handleNavigationToPattern}>
                        <StyledMenuIcon
                            className='stolo-appbar-menu' name='icon-palette'
                            width='1.5rem' height='1.5rem'
                            iconColor={'blueGrey.700'}
                        />
                        <StyledMenuText>{this.props.labelColoring}</StyledMenuText>
                    </MenuItem>
                </Menu>
            </Fragment>
        );
    }

}


const mapDispatchToProps = dispatch => (
    {
        showSavedToClipBoard: id => dispatch(showSnack(
            id,
            'SNACK_LINK_COPIED_TO_CLIPBOARD',
            null,
            3000,
            null,
        )),
    }
);

const makeMapStateToProps = (initialState, initialOwnProps) => {
    const sharePinterestLabel = getMessage(
        initialState,
        'SHARE_ON_PINTEREST_BUTTON_LABEL',
    );
    const sharePinterestPrefix = getMessage(
        initialState,
        'SHARE_ON_PINTEREST_DEFAULT_PREFIX',
    );
    const shareMenuLabel = getMessage(initialState, 'ICON_LABEL_SHARE');
    const shareLinkLabel = getMessage(initialState, initialOwnProps.messageId ||
        'SHARE_COPY_LINK_BUTTON_LABEL');
    const labelColoring = getMessage(initialState, 'ICON_LABEL_COLORING');
    const mapStateToProps = state => (
        {
            sharePinterestLabel,
            sharePinterestPrefix,
            shareLinkLabel,
            shareMenuLabel,
            labelColoring,
            shareBaseUri: getCurrentBaseUri(state),
            ...initialOwnProps,
        }
    );
    return mapStateToProps;
};

PatternGalleryActionBarMenu.propTypes = {
    pattern: propTypes.object.required,
    imgSrc: propTypes.string,
    shareBaseUri: propTypes.string,
    navigateToPattern: propTypes.func.required,
    showSavedToClipBoard: propTypes.func,
    sharePinterestLabel: propTypes.string,
    sharePinterestPrefix: propTypes.string,
    shareLinkLabel: propTypes.string,
    shareMenuLabel: propTypes.string,
    labelColoring: propTypes.string,
    labelSelectFabric: propTypes.string,
    query: propTypes.object,
};

export default connect(
    makeMapStateToProps,
    mapDispatchToProps,
)(
    PatternGalleryActionBarMenu);



// WEBPACK FOOTER //
// ./src/components/patterngalleries/PatternGalleryActionBarMenu.js